import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { ParentTable } from '@mq/voltron-parent';
import { Table } from '@mq/voltron-table';
import { LoadingOverlay, VSpacer } from '@mqd/volt-base';
import StyleContext from '../contexts/StyleContext';
import { mockData } from './mockData';

class BusinessDirectorsTable extends ParentTable {
  constructor(props) {
    super(props);
    this.state = this.colEditState(props, this.columns());
  }

  columns() {
    return [
      {
        header: 'First Name',
        accessor: 'first_name',
        key: 'first_name',
        primaryKey: true,
      },
      {
        header: 'Middle Name',
        accessor: 'middle_name',
        key: 'middle_name',
      },
      {
        header: 'Last Name',
        accessor: 'last_name',
        key: 'last_name',
      },
      {
        header: 'Email',
        accessor: 'email',
        key: 'email',
      },
      {
        header: 'Phone',
        accessor: 'phone',
        key: 'phone',
      },
      {
        header: 'Title',
        accessor: 'title',
        key: 'title',
      },
      {
        header: 'Token',
        accessor: 'token',
        key: 'token',
      },
      {
        header: 'Nationality',
        accessor: 'nationality',
        key: 'nationality',
      },
      {
        header: 'Place of Birth',
        accessor: 'place_of_birth',
        key: 'place_of_birth',
      },
    ];
  }

  render() {
    const { loading: detailLoading, calculateTableHeight } = this.props;
    const { columns, tableKey } = this.state;
    const tablePaddingBottom = calculateTableHeight();

    return (
      <div style={{ width: '100%' }} data-testid="business-directors-table-wrapper">
        <VSpacer />
        <StyleContext.Consumer>
          {({ height }) => {
            return (
              <LoadingOverlay active={detailLoading}>
                <Table
                  key={tableKey}
                  height={height + tablePaddingBottom || this.dynamicHeight}
                  data={mockData}
                  columns={columns}
                  testId="business-directors-table"
                />
              </LoadingOverlay>
            );
          }}
        </StyleContext.Consumer>
      </div>
    );
  }
}

BusinessDirectorsTable.propTypes = {
  height: PropTypes.number,
  title: PropTypes.any,
  localStorageKey: PropTypes.string,
  calculateTableHeight: PropTypes.func,
};

BusinessDirectorsTable.defaultProps = {
  height: 800,
  title: 'Directors',
  localStorageKey: 'BusinessDirectorsTableConfig',
  calculateTableHeight: () => 0,
};

export default observer(BusinessDirectorsTable);
